import { footerLinks, footerNotice } from "@/mocks/doumanData";

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-open-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">抖漫导航</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
              本站整理抖漫官网入口、APP 下载方式与最新可用地址，帮助你快速找到访问途径，顺畅在线阅读海量漫画资源。
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading font-bold text-sm text-background-50">
              <a href="#top" className="hover:text-primary-300 transition-colors cursor-pointer">页内导航</a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 lg:grid-cols-1 gap-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-heading font-bold text-sm text-background-50">
              <a href="#safety" className="hover:text-primary-300 transition-colors cursor-pointer">免责与说明</a>
            </h4>
            <ul className="mt-4 space-y-3">
              {footerNotice.map((text) => (
                <li key={text} className="flex items-start gap-2 text-xs leading-relaxed text-background-200">
                  <i className="ri-information-line mt-0.5 shrink-0" aria-hidden="true"></i>
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300">© 2026 抖漫导航 · 内容整理仅供参考</p>
          <p className="text-xs text-background-300">本页不提供账号注册与任何交易服务</p>
        </div>
      </div>
    </footer>
  );
}